<template>
  <div>
    <el-table
      :data="eventsSliced"
      style="width: 100%"
      row-key="id"
      size="small"
      empty-text="Aucun événement trouvé"
    >
      <el-table-column
        prop="createdAt"
        label="Créé le"
        width="90"
        align="center"
      >
        <template slot-scope="scope">
          {{ formatDate(scope.row.createdAt) }}
        </template>
      </el-table-column>

      <el-table-column prop="type" label="Type" width="180" align="center">
        <template slot-scope="scope">
          <span
            >{{ scope.row.type }}
            <el-popover v-if="scope.row.notes" placement="top" trigger="hover">
              <div>{{ scope.row.notes }}</div>
              <template #reference>
                <i class="fa fa-info-circle ml-05"></i>
              </template>
            </el-popover>
          </span>
        </template>
      </el-table-column>

      <el-table-column
        prop="relatedTo"
        label="Lié au client"
        min-width="150"
      ></el-table-column>

      <el-table-column
        prop="viewedAt"
        label="Vu le"
        min-width="150"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.viewedAt">
            {{ formatDateTime(scope.row.viewedAt) }}
          </span>

          <button
            v-else-if="
              !scope.row.viewedAt &&
              hasPermission($store.state.user, 'USERS_WRITE')
            "
            class="btn btn-primary btn-sm"
            @click="setViewedAt(scope.row)"
          >
            Marqué comme vu
          </button>
        </template>
      </el-table-column>
    </el-table>

    <paginate
      v-if="pageCount > 1"
      style="margin-top: 20px; margin-left: 20px"
      v-model="page"
      :page-count="pageCount"
      :click-handler="changePage"
      prev-text="Précédent"
      next-text="Suivant"
      container-class="pagination"
    ></paginate>
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";

export default {
  components: {
    Paginate,
  },

  props: {
    eventType: {
      type: String,
      required: true,
    },
    eventsData: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      offset: 0,
      limit: 10,
      page: 1,
      dataEvents: this.eventsData,
    };
  },

  computed: {
    events() {
      const regexUuid =
        /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;

      return this.dataEvents.map((event) => {
        let relatedTo;

        if (event.clientName) {
          relatedTo = event.clientName;
        }

        if (!regexUuid.test(event.relatedTo)) {
          relatedTo = event.relatedTo;
        }

        return {
          ...event,
          relatedTo: relatedTo || "",
        };
      });
    },

    pageCount() {
      return Math.ceil(this.events.length / this.limit);
    },

    eventsSliced() {
      return this.events.slice(this.offset, this.offset + this.limit);
    },
  },
  methods: {
    changePage(page) {
      this.page = page;
      this.offset = this.limit * page - this.limit;
    },

    async setViewedAt(dataEvent) {
      try {
        const { data } = await this.$api.patch(
          `/users/events/${dataEvent.id}/viewed`,
          {
            coachEmail: dataEvent.userEmail,
            coachId: dataEvent.userId,
            eventType: this.eventType,
          }
        );

        if (this.eventType === "assistantEvents") {
          this.dataEvents = this.events.map((event) => {
            if (event.id === data.id) {
              return { ...event, viewedAt: data.viewedAt };
            }

            return event;
          });
        } else {
          this.dataEvents = this.events.filter((event) => event.id !== data.id);
        }

        this.$successToast("L'événement a été marqué comme vu.");
      } catch (_) {
        this.$errorToast(
          "Impossible de marquer l'événement comme vu, une erreur est survenue."
        );
      }
    },
  },
};
</script>
